<template>
  <div class="topbar-content as-flex main-start cross-center">
    <div class="tab-page-container">
      <tabpage></tabpage>
    </div>
    <el-popover
      class="userinfo-container"
      popper-class="userinfoBox"
      placement="bottom-start"
      trigger="hover"
    >
      <div class="as-full-height as-full-width">
        <userInfoBox :userInfo="userInfo"></userInfoBox>
      </div>
      <div slot="reference" class="as-full-width as-full-height as-flex main-end cross-center">
        <span class="profile-name f-2">{{userInfo?userInfo.company:'--'}}</span>
        <img class="profile-img" src="../assets/images/userinfo-profile.png" alt>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import userInfoBox from "./topBar/userInfoBox.vue";
import tabpage from "./topBar/tabpage.vue";
export default {
  name: "topBar",
  props: {},
  components: {
    userInfoBox: userInfoBox,
    tabpage: tabpage
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      userInfo: "user/getUserInfo"
    })
  },
  methods: {},
  watch: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.topbar-content {
  width: 100%;
  height: 100%;
  padding: 5px 10px;
}
.tab-page-container {
  width: 85%;
  height: 100%;
  // background-color: aquamarine;
}
.userinfo-container {
  position: relative;
  padding: 0 10px;
  width: 15%;
  height: 100%;
  .profile-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #999999;
    padding: 0 5px;
  }
  .profile-img {
    width: 25px;
    height: 25px;
  }
}
</style>